import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import api from "@/lib/api";
import { AdminLayout } from "@/pages/admin/AdminLayout";

export default function Sponsored() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(null);
  const load = useCallback(() => { api.get("/admin/sponsored").then((r) => setItems(r.data || [])).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);
  const save = async () => { if (!form.sponsor) return toast.error("Sponsor required"); await api.post("/admin/sponsored", form); toast.success("Saved"); setForm(null); load(); };
  const inp = "w-full bg-admbg border border-admborder px-2.5 py-1.5 text-admtext text-sm outline-none focus:border-cyan";
  return (
    <AdminLayout title="Sponsored Content">
      <div className="flex justify-between items-center mb-4">
        <p className="text-sm text-admtext2">Track commercial campaigns. Sponsored articles always carry a visible disclosure on the public site.</p>
        <button onClick={() => setForm({ sponsor:"", company:"", campaign:"", contact:"", link:"", price:"", payment_status:"pending", notes:"" })}
          className="flex items-center gap-1.5 bg-crimson text-white px-4 py-2 text-xs font-bold uppercase tracking-wider hover:bg-crimsonhover" data-testid="add-sponsored-button"><Plus size={14} /> Add Campaign</button>
      </div>
      {form && (
        <div className="bg-admcard border border-cyan p-5 mb-4 grid grid-cols-2 md:grid-cols-3 gap-3">
          <input placeholder="Sponsor" className={inp} value={form.sponsor} onChange={(e) => setForm({...form, sponsor:e.target.value})} />
          <input placeholder="Company" className={inp} value={form.company} onChange={(e) => setForm({...form, company:e.target.value})} />
          <input placeholder="Campaign" className={inp} value={form.campaign} onChange={(e) => setForm({...form, campaign:e.target.value})} />
          <input placeholder="Contact" className={inp} value={form.contact} onChange={(e) => setForm({...form, contact:e.target.value})} />
          <input placeholder="Link" className={inp} value={form.link} onChange={(e) => setForm({...form, link:e.target.value})} />
          <input placeholder="Price" className={inp} value={form.price} onChange={(e) => setForm({...form, price:e.target.value})} />
          <select className={inp} value={form.payment_status} onChange={(e) => setForm({...form, payment_status:e.target.value})}><option value="pending">Pending</option><option value="paid">Paid</option><option value="invoiced">Invoiced</option></select>
          <input placeholder="Notes" className={inp + " col-span-2"} value={form.notes} onChange={(e) => setForm({...form, notes:e.target.value})} />
          <div className="col-span-2 md:col-span-3 flex gap-2"><button onClick={save} className="bg-cyan text-admbg px-4 py-1.5 text-xs font-bold uppercase">Save</button><button onClick={() => setForm(null)} className="border border-admborder text-admtext2 px-4 py-1.5 text-xs uppercase">Cancel</button></div>
        </div>
      )}
      <div className="bg-admcard border border-admborder">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-admmuted text-xs uppercase tracking-wider border-b border-admborder">
            <th className="px-5 py-3">Sponsor</th><th className="px-3 py-3">Company</th><th className="px-3 py-3">Campaign</th><th className="px-3 py-3">Price</th><th className="px-3 py-3">Payment</th>
          </tr></thead>
          <tbody>
            {items.map((s) => (
              <tr key={s.id} className="border-b border-admborder last:border-0 text-admtext2">
                <td className="px-5 py-3 text-admtext">{s.sponsor}</td><td className="px-3 py-3">{s.company}</td><td className="px-3 py-3">{s.campaign}</td>
                <td className="px-3 py-3 font-mono">{s.price || "—"}</td>
                <td className="px-3 py-3"><span className={s.payment_status === "paid" ? "text-emerald" : "text-amber"}>{s.payment_status}</span></td>
              </tr>
            ))}
            {!items.length && <tr><td colSpan={5} className="px-5 py-8 text-admmuted text-center">No campaigns yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
